import type { InitOptions } from 'i18next';

import { initReactI18next } from 'react-i18next';
import HttpBackend from 'i18next-http-backend';
import i18n from 'i18next';

declare global {
  interface Window {
    initialI18nStore?: Record<string, any>;
    initialLanguage?: string;
  }
}

const availableLanguages = ['en', 'fr'];

// Variables provided by SSR system
const store = window.initialI18nStore || {};
const initialLng = window.initialLanguage;

const i18nConfig: InitOptions = {
  debug: false,
  load: 'languageOnly',
  initImmediate: false,
  fallbackLng: 'en',
  defaultNS: 'commonPlat',
  nonExplicitSupportedLngs: true,
  supportedLngs: availableLanguages,
  lng: initialLng,

  interpolation: {
    escapeValue: false, // react already safes from xss
  },

  //preload: availableLanguages,

  backend: {
    loadPath: '/locales/{{lng}}/{{ns}}.json',
  },

  react: {
    useSuspense: true,
    transKeepBasicHtmlNodesFor: ['br', 'strong', 'i', 'small', 'p', 'em'],
  },
  showSupportNotice: false, // Disable the advertisements in the console logs
};

i18n
  .use(initReactI18next) // passes i18n down to react-i18next
  .use(HttpBackend);

await i18n.init(i18nConfig);

for (const [lang, namespaces] of Object.entries(store)) {
  for (const [ns, resources] of Object.entries(namespaces as any)) {
    i18n.addResourceBundle(lang, ns, resources, true /* deep */, true /* overwrite */);
  }
}

export default i18n;
